var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"main"},[_c('Jumbotron'),_c('Projects',{attrs:{"id":"Proyectos"}}),_c('AboutMe',{attrs:{"id":"SobreMi"}}),_c('Contacto',{attrs:{"id":"Contacto"}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }